<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Push Notification' : 'Add Push Notification'"
>
</nz-page-header>

<form nz-form [formGroup]="addUpdateNotifForm">
  <nz-card nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <!-- ══════════════════════════════════════════════════════════
           LEFT  –  Main fields  (18 cols)
           ══════════════════════════════════════════════════════════ -->
      <div nz-col nzLg="18" nzMd="18" nzSm="24" nzXs="24">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <!-- Title -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="title" nzRequired
                >Title</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  nz-input
                  formControlName="title"
                  placeholder="Enter notification title"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Notification Type -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="type" nzRequired
                >Notification Type</nz-form-label
              >
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-select
                  formControlName="type"
                  nzPlaceHolder="Select type"
                  (ngModelChange)="onTypeChange($event)"
                >
                  <nz-option
                    *ngFor="let o of typeOptions"
                    [nzValue]="o.value"
                    [nzLabel]="o.label"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- ── Exam Category select (type = examCategory) ───────── -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="currentType === 'examCategory'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="examCategoryId">
                Select Exam Category
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  formControlName="examCategoryId"
                  nzPlaceHolder="Search exam category"
                  [nzLoading]="examCategoryLoading"
                  (nzOnSearch)="onExamCategorySearch($event)"
                  (nzScrollToBottom)="loadMoreExamCategories()"
                  (ngModelChange)="onExamCategoryChange()"
                >
                  <nz-option
                    *ngFor="let cat of examCategoryList"
                    [nzValue]="cat._id"
                    [nzLabel]="cat.categoryName || cat.title || cat._id"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- ── Plan select (type = plan) ────────────────────────── -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="currentType === 'plan'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="planId"
                >Select Plan</nz-form-label
              >
              <nz-form-control [nzSpan]="24">
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  formControlName="planId"
                  nzPlaceHolder="Search active plans"
                  [nzLoading]="planLoading"
                  (nzOnSearch)="onPlanSearch($event)"
                  (nzScrollToBottom)="loadMorePlans()"
                  (ngModelChange)="onPlanIdChange($event)"
                >
                  <nz-option
                    *ngFor="let p of planList"
                    [nzValue]="p._id"
                    [nzLabel]="p.name || p.title || p._id"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <!-- ─────────────────────────────────────────────────────── -->

          <!-- Description -->
          <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="description"
                >Description</nz-form-label
              >
              <nz-form-control [nzSpan]="24">
                <textarea
                  nz-input
                  formControlName="description"
                  placeholder="Short body text shown in the notification..."
                  [nzAutosize]="{ minRows: 3, maxRows: 6 }"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- ── Send Now switch ──────────────────────────────────── -->
          <div nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Send Now</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <div class="send-now-row">
                  <nz-switch
                    formControlName="sendNow"
                    nzCheckedChildren="Yes"
                    nzUnCheckedChildren="No"
                  ></nz-switch>
                  <span class="send-now-hint">
                    Toggle on to send immediately — skips scheduling
                  </span>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Schedule Date — hidden when sendNow -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="!isSendNow"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="scheduleDate" nzRequired>
                Schedule Date &amp; Time
              </nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-date-picker
                  class="width-100"
                  nzShowTime
                  nzFormat="yyyy-MM-dd HH:mm:ss"
                  formControlName="scheduleDate"
                  nzPlaceHolder="Select date & time"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- End Date -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="endDate" nzRequired
                >End Date &amp; Time</nz-form-label
              >
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Should not be blank"
                nzExtra="Notification stops running after this date"
              >
                <nz-date-picker
                  class="width-100"
                  nzShowTime
                  nzFormat="yyyy-MM-dd HH:mm:ss"
                  formControlName="endDate"
                  nzPlaceHolder="Select end date & time"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Repeat Type -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="repeatDaysType"
                >Repeat</nz-form-label
              >
              <nz-form-control [nzSpan]="24">
                <nz-select
                  formControlName="repeatDaysType"
                  nzPlaceHolder="Select repeat interval"
                >
                  <nz-option
                    *ngFor="let o of repeatDaysTypeOptions"
                    [nzValue]="o.value"
                    [nzLabel]="o.label"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Custom repeat days — only when repeatDaysType = 'custom' -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="isCustomRepeat"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="repeatDays" nzRequired>
                Repeat Every (days)
              </nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Enter a value of at least 1"
              >
                <nz-input-number
                  class="width-100"
                  formControlName="repeatDays"
                  [nzMin]="1"
                  [nzStep]="1"
                  nzPlaceHolder="e.g. 3"
                ></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- ── Target Audience — only visible when type = 'user' ── -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="currentType === 'user'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="targetAudience"
                >Target Audience</nz-form-label
              >
              <nz-form-control [nzSpan]="24">
                <nz-select
                  formControlName="targetAudience"
                  nzPlaceHolder="Select audience"
                  (ngModelChange)="onAudienceChange($event)"
                >
                  <nz-option
                    *ngFor="let o of targetAudienceOptions"
                    [nzValue]="o.value"
                    [nzLabel]="o.label"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- ── Target Module ────────────────────────────────────── -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="currentType !== 'plan'"
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="targetModule"
                >Target Module</nz-form-label
              >
              <nz-form-control [nzSpan]="24">
                <nz-select
                  nzAllowClear
                  formControlName="targetModule"
                  nzPlaceHolder="Select module"
                  (ngModelChange)="onModuleChange($event)"
                >
                  <nz-option
                    *ngFor="let m of moduleList"
                    [nzValue]="m.value"
                    [nzLabel]="m.label"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- ── Reference item — shown when a module is selected ─── -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="
              currentModule &&
              currentType !== 'plan' &&
              currentModule !== 'freeMock'
            "
          >
            <nz-form-item>
              <nz-form-label
                [nzSpan]="24"
                nzFor="referenceId"
                [nzRequired]="currentModule === 'testSery'"
              >
                Select {{ getModuleLabel(currentModule) }}
              </nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Please select a reference item"
              >
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  formControlName="referenceId"
                  [nzPlaceHolder]="'Search ' + getModuleLabel(currentModule)"
                  [nzLoading]="moduleLoading"
                  (nzOnSearch)="onModuleSearch($event)"
                  (nzScrollToBottom)="loadMoreModuleData()"
                >
                  <nz-option
                    *ngFor="let item of moduleData"
                    [nzValue]="item._id"
                    [nzLabel]="getModuleItemLabel(currentModule, item)"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <!-- ─────────────────────────────────────────────────────── -->
        </div>
      </div>
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="image">
            Notification Image (1024px × 512px)
          </nz-form-label>
          <div *ngIf="!uploadImageSizeMessage" class="upload-size-info">
            Recommended image size: <strong>300 KB to 1 MB</strong>. Please
            optimize your image for best performance.
          </div>
          <div
            *ngIf="uploadImageSizeMessage"
            class="upload-size-info"
            [ngClass]="uploadImageSizeLevel"
          >
            {{ uploadImageSizeMessage }}
          </div>
          <nz-upload
            *ngIf="!addUpdateNotifForm.value.image"
            class="upload-list-inline"
            [nzName]="'file'"
            [nzShowUploadList]="false"
            [nzBeforeUpload]="beforeImageUpload"
            [nzAction]="mediaUploadUrl"
            [nzHeaders]="customRequestHeaders"
            (nzChange)="UploadImageFile($event)"
          >
            <button nz-button [nzLoading]="imageLoading">
              <span nz-icon nzType="upload"></span> Upload
            </button>
          </nz-upload>

          <div
            class="image-preview-card"
            *ngIf="addUpdateNotifForm.value.image"
          >
            <div class="image-preview-wrapper">
              <img
                nz-image
                class="image-preview-img"
                [nzSrc]="mediaBaseUrl + addUpdateNotifForm.value.image"
                alt="Notification image"
              />
            </div>
            <div class="image-action-row">
              <a
                nz-button
                nzType="text"
                nzTooltipTitle="Download"
                nz-tooltip
                [href]="mediaBaseUrl + addUpdateNotifForm.value.image"
                target="_blank"
                download
                class="image-action-btn"
              >
                <span nz-icon nzType="download"></span>
              </a>
              <button
                nz-button
                nzType="text"
                nzDanger
                nzTooltipTitle="Delete"
                nz-tooltip
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete this image?"
                (nzOnConfirm)="removeImage()"
                class="image-action-btn"
              >
                <span nz-icon nzType="delete"></span>
              </button>
            </div>
          </div>
        </nz-form-item>
      </div>
      <!-- END RIGHT ═════════════════════════════════════════════════ -->
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         TEST NOTIFICATION SECTION
         Shown only when all required fields are valid
         ══════════════════════════════════════════════════════════════ -->
    <div class="test-notification-section" *ngIf="isFormReadyForTest">
      <nz-divider nzDashed>
        <span class="test-divider-label">
          <span nz-icon nzType="experiment" nzTheme="outline"></span>
          Test Before Sending
        </span>
      </nz-divider>

      <div
        nz-row
        [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }"
        nzAlign="bottom"
      >
        <!-- Test switch -->
        <div nz-col nzLg="6" nzMd="8" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Enable Test Mode</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <div class="send-now-row">
                <nz-switch
                  [(ngModel)]="testModeEnabled"
                  [ngModelOptions]="{ standalone: true }"
                  nzCheckedChildren="On"
                  nzUnCheckedChildren="Off"
                  (ngModelChange)="onTestModeToggle($event)"
                ></nz-switch>
                <span class="send-now-hint"
                  >Send a test to a mobile number</span
                >
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Mobile number input + Send Test button — visible only when test mode is on -->
        <ng-container *ngIf="testModeEnabled">
          <div nz-col nzLg="8" nzMd="10" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>
                Mobile Number
              </nz-form-label>
              <nz-form-control [nzSpan]="24" [nzErrorTip]="mobileErrorTip">
                <nz-input-group [nzAddOnBefore]="countryCodeTpl">
                  <input
                    nz-input
                    [(ngModel)]="testMobileNumber"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Enter 10-digit mobile number"
                    maxlength="10"
                    (input)="onMobileInput()"
                    [class.ng-dirty]="mobileValidationDirty"
                    [class.ng-invalid]="mobileValidationDirty && !isMobileValid"
                  />
                </nz-input-group>
                <ng-template #countryCodeTpl>+91</ng-template>
              </nz-form-control>
              <div
                class="mobile-error-msg"
                *ngIf="mobileValidationDirty && !isMobileValid"
              >
                {{ mobileErrorTip }}
              </div>
            </nz-form-item>
          </div>

          <div
            nz-col
            nzLg="6"
            nzMd="6"
            nzSm="24"
            nzXs="24"
            class="test-btn-col"
          >
            <button
              nz-button
              nzType="default"
              class="send-test-btn"
              [disabled]="!isMobileValid"
              nz-popconfirm
              nzPopconfirmTitle="Send a test notification to +91 {{
                testMobileNumber
              }}?"
              nzPopconfirmPlacement="top"
              nzOkText="Yes, Send Test"
              nzCancelText="Cancel"
              (nzOnConfirm)="sendTestNotification()"
            >
              <span nz-icon nzType="send" nzTheme="outline"></span>
              Send Test
            </button>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- END TEST SECTION ══════════════════════════════════════════════ -->

    <!-- Submit row -->
    <div nz-row nzJustify="end">
      <button
        nz-button
        nzType="primary"
        [nzLoading]="buttonLoading"
        (click)="submit()"
        class="submitoraddbutton"
      >
        {{ idForUpdate ? "Update" : "Submit" }}
      </button>
    </div>
  </nz-card>
</form>
